import { AnalyticsService, CommonAnalyticsModalName } from '@ui-common/analytics'
import { useEffect, useRef } from 'react'

export const useSendModalViewEvent = <TPageEvent, TCustomEventName, TModalEvent extends CommonAnalyticsModalName>(
  analyticsService: AnalyticsService<TPageEvent, TCustomEventName, TModalEvent>,
  name: TModalEvent,
): void => {
  const lastSentPage = useRef<TModalEvent | null>(null)

  useEffect(() => {
    // Avoid sending same page view multiple times in a row (React StrictMode)
    if (name !== lastSentPage.current) {
      analyticsService.sendModalViewEvent(name)
      lastSentPage.current = name
    }
  }, [analyticsService, name])
}
